import { Reviewed } from '../../models/forecast.model';
import { DummyCommitHeader, EnumSvSidebarSection } from '../../models/supply-visibility.model';
import {
  CommitStatusLabel,
  CommitStatusOption,
  SupplyVisibilityStateModel,
} from './supply-visibility.types';

export const COMMITS_COLUMN_LIST = 'column_list-commits';

export const COMMITS_MODULE_FIELDS_KEY = 'COMMIT_MODULE_FORMKEY';

export const COMMITS_HISTORY_FIELDS_KEY = 'COMMIT_HISTORY_FORMKEY';

export const defaultSupplyVisibilityState: SupplyVisibilityStateModel = {
  additionalFilters: [],
  basicParameters: {
    mmViewID: '',
    partNumber: '',
    plant: '',
    records: 0,
    variant: '',
    vendorCode: '',
  },
  buyersPartNumbers: [],
  cachedChildrenPNInfo: undefined,
  cachedCommits: undefined,
  cachedCommitsHash: '',
  cachedForecast: undefined,
  cachedForecastHash: '',
  cachedReadOnlyFields: [],
  // cachedChildrenForecast: null,
  childrenPNInfo: undefined,
  childrenPNList: undefined,
  commitMandatoryDates: [],
  commitModuleOn: false,
  commits: [],
  commitStatus: '',
  commitTransactionDetails: [],
  commitVendorCode: '',
  daterangeParameters: {
    dateFrom: '',
    dateTo: '',
  },
  DefaultDashboardData: { defaultDashboardId: {}, isLogin: false, isPlantChanged: false },
  dummyCommitsHeaders: [],
  forecast: {
    days: undefined,
    materialManagementViewID: '',
    mergeProjections: [],
    partNumber: '',
    plant: '',
    projectionDetails: [],
    reviewed: null as unknown as Reviewed,
    staticvalues: [],
    vendorCode: '',
    weeks: undefined,
  },
  forecastWeekRange: {
    endWeek: 0,
    startWeek: 0,
  },
  materialManagementViews: [],
  newCommit: {},
  newUserSettings: { data: '', key: '' },
  notificationDetailCache: {},
  notifications: [],
  notificationsUnreadCount: 0,
  partNumberListParameters: {},
  partnumberTransactionDetails: [],
  purchaseOrders: [],
  // quotationTransactionDetails: [],
  selectedDummyCommitHeader: null as unknown as DummyCommitHeader,
  svComments: [],
  svNotes: [],
  svNotesCount: 0,
  svPredefinedComments: [],
  userAction: EnumSvSidebarSection.None,
  userSettingParameters: { key: '' },
  userSettings: { data: '', key: '' },
  vendorCodes: [],
  vendorList: '',
  vendorTransactionDetails: [],
};

export const COMMIT_STATUS_OPTIONS: readonly CommitStatusOption[] = [
  { id: 'D', name: CommitStatusLabel.DELIVERED },
  { id: 'N', name: CommitStatusLabel.NEW },
  { id: 'M', name: CommitStatusLabel.INITIAL_TRIGGERS },
  { id: 'W', name: CommitStatusLabel.WAITING },
  { id: 'P', name: CommitStatusLabel.PARTIAL },
] as const;

/**
 * Namespace the commit columns are translated from, by field name.
 */
export const COMMITS_COLUMN_LABEL_PREFIX = 'commits.';

/** User-settings key the commit form's field arrangement is stored under. */
export const COMMIT_FORM_FIELD_LIST = 'commit_field_list';

/** Form key naming the fields the plant allows on the commit form. */
export const COMMIT_FORM_FIELDS_KEY = 'COMMIT_DETAIL_FORMKEY';
